var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.406 13.966h-2.438v-2.291h2.438v2.291Zm-12.187 0H23.78v-2.291h2.438v2.291ZM39.698 7.46l3.193-3.002a1.126 1.126 0 0 0 0-1.627c-.488-.435-1.268-.435-1.73 0l-3.608 3.391a15.5 15.5 0 0 0-6.46-1.42c-2.34 0-4.533.527-6.483 1.443L20.978 2.83a1.278 1.278 0 0 0-1.706 0c-.487.458-.487 1.191 0 1.627l3.193 3.002c-3.632 2.52-5.996 6.507-5.996 11.09h29.25c0-4.583-2.438-8.593-6.02-11.09h-.001Zm12.115 13.38c-2.02 0-3.657 1.539-3.657 3.437v16.04c0 1.898 1.637 3.437 3.657 3.437 2.019 0 3.656-1.539 3.656-3.437v-16.04c0-1.898-1.637-3.437-3.656-3.437Zm-41.438 0c-2.02 0-3.656 1.539-3.656 3.437v16.04c0 1.898 1.637 3.437 3.656 3.437 2.02 0 3.656-1.539 3.656-3.437v-16.04c0-1.898-1.637-3.437-3.656-3.437Zm6.093 22.914c0 1.265 1.092 2.291 2.438 2.291h2.437v8.02c0 .912.386 1.786 1.071 2.43A3.778 3.778 0 0 0 25 57.504c2.019 0 3.656-1.538 3.656-3.437v-8.02h4.875v8.02c0 1.899 1.636 3.437 3.656 3.437 2.019 0 3.656-1.538 3.656-3.437v-8.02h2.437c1.346 0 2.438-1.026 2.438-2.291V20.841h-29.25v22.914Z",
    fill: "#8BC34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.5dbe1ebdfe1a9ffaf93811e93d4ad713.svg";
export { ForwardRef as ReactComponent };